module.exports = __webpack_public_path__ + "img/on-off-icon.9c12bf2d.svg";